<template>
    <div style="width: 100%;" class="d-flex align-center">
        <div style="min-width: 10px">
            <v-divider></v-divider>
        </div>
        <div class="grey--text px-1">
            <slot>{{label}}</slot>
        </div>
        <div class="flex-grow-1">
            <v-divider></v-divider>
        </div>

        <template v-if="showSearch">
            <v-text-field
                    ref="filter"
                    placeholder="Search"
                    hide-details
                    class="pa-0 ma-0 mx-1"
                    color="primary"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    v-model="searchModel"
                    style="max-width: 300px"
                    @focus="$event.target.select()"
            ></v-text-field>

            <div style="min-width: 20px">
                <v-divider></v-divider>
            </div>
        </template>


        <template v-if="hasActionSlot">
            <div class="px-1">
                <slot name="action"></slot>
            </div>
            <div style="min-width: 20px">
                <v-divider></v-divider>
            </div>
        </template>

        <div class="d-flex align-center" v-if="$props.showExpanded">

            <v-tooltip top>
                <template v-slot:activator="{on}">
                    <v-btn
                            small
                            icon
                            color="grey"
                            @click="$emit('update:expanded', !expanded)"
                            v-on="on"
                    >
                        <v-icon>{{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                    </v-btn>
                </template>
                {{ expanded ? "Collapse" : "Expand" }}
            </v-tooltip>

            <div style="min-width: 20px">
                <v-divider></v-divider>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {type: String, default: ''},
        showSearch: {type: Boolean, default: false},
        search: {type: String, default: null},
        showExpanded: {type: Boolean, default: false},
        expanded: Boolean
    },
    data() {
        return {
            showSearchBox: false
        }
    },
    methods: {
        test() {

        }
    },
    computed: {
        hasActionSlot() {
            return !!this.$slots.action
        },
        searchModel: {
            get() {
                return this.search
            },
            set(val) {
                this.$emit('update:search', val)
            }
        }
    },
}
</script>

<style scoped>

</style>